require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-sitecore-jss.json") })
        }
      }, "path---tags-sitecore-jss");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-sitecore-jss!./.cache/json/tags-sitecore-jss.json
// module id = 385
// module chunks = 231608221292675